import FnrFetch3 from "Utilities/FnrFetch/FnrFetch3";

export async function getBrisbaneReport() {
  let endpoint = "/ClientSpecific/Brisbane/Export";

  // This is a temporary solution to get the report for the Brisbane network locally during development.
  if (process.env.NODE_ENV === "development") {
    endpoint = "/ClientSpecific/Brisbane/Export?networkIdOverride=3";
  }

  const fetchFunction = new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) => {
    throw err;
  });

  return response;
}